<template>
  <div class="profilo">
    <div class="col-24 no-padding">

      <el-tabs v-model="tabActive" type="card" class="col-24" v-loading="loading" @tab-click="tabClick">
        <el-tab-pane name="mailForm">
          <div style="width: 200px" slot="label">
            <div class="col-24 no-padding">
              {{ $t('profilo.label.mail').toUpperCase() }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div class="form-profilo">
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.mail') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="mailForm.mail" clearable autocomplete="off"></el-input>
              </div>
            </div>
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.password') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="mailForm.pwd" type="password" clearable autocomplete="off"></el-input>
              </div>
            </div>
          </div>
          <div class="action">
            <el-button class="WEB-button WEB-button-primary" @click="changeMail">
              {{ $t('profilo.btn.salva') }}
            </el-button>
          </div>

        </el-tab-pane>

        <el-tab-pane name="questionForm">
          <div style="width: 200px" slot="label">
            <div class="col-24 no-padding">
              {{ $t('profilo.label.domanda').toUpperCase() }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>

          <div class="form-profilo">
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.domanda') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-select v-model="questionForm.question" @change="clearError(3)">
                  <el-option v-for="item in secretQuestions" :key="item.value" :label="$t('questions.' + item.value)"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.risposta') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="questionForm.answer" type="password" clearable
                  autocomplete="off"></el-input>
              </div>
            </div>
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.password') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="questionForm.pwd" type="password" clearable
                  autocomplete="off"></el-input>
              </div>
            </div>
          </div>
          <div class="action">
            <el-button class="WEB-button WEB-button-primary" @click="changeQuest">
              {{ $t('profilo.btn.salva') }}
            </el-button>
          </div>

        </el-tab-pane>

        <el-tab-pane name="pwdForm">
          <div style="width: 200px" slot="label">
            <div class="col-24 no-padding">
              {{ $t('profilo.label.password').toUpperCase() }}
            </div>
            <div class="col-24 no-padding barra"></div>
          </div>


          <div class="form-profilo">
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.passwordOld') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="pwdForm.oldPwd" type="password" clearable
                  autocomplete="off"></el-input>
              </div>
            </div>
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.passwordNew') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="pwdForm.newPwd" type="password" clearable
                  autocomplete="off"></el-input>
              </div>
            </div>
            <div class="row row-custom modifica">
              <div class="profilo-label col-8 no-padding">
                {{ $t('profilo.label.passwordRep') }}
              </div>
              <div class="profilo-value col-16 no-padding">
                <el-input placeholder="" v-model="pwdForm.newPwdRep" type="password" clearable
                  autocomplete="off"></el-input>
              </div>
            </div>
          </div>
          <div class="action">
            <el-button class="WEB-button WEB-button-primary" @click="changePwd">
              {{ $t('profilo.btn.salva') }}
            </el-button>
          </div>

        </el-tab-pane>

      </el-tabs>


    </div>
  </div>

</template>

<script>
export default {
  components: {},
  name: 'Profilo',
  props: ['contenitoreHeight', 'userProfile'],
  i18n: {
    messages: {
      it_IT: {
        profilo: {
          label: {
            mail: 'e-mail',
            modifica: 'Modifica',
            domanda: 'Domanda Segreta',
            risposta: 'Risposta Segreta',
            password: 'Password',
            passwordOld: 'Vecchia Password',
            passwordNew: 'Nuova Password',
            passwordRep: 'Conferma Password'
          },
          btn: {
            salva: 'Salva',
            annulla: 'Annulla'
          }
        }
      },
      fr_FR: {
        profilo: {
          label: {
            mail: 'e-mail',
            modifica: 'Modifier',
            domanda: 'Question secrète',
            risposta: 'Reponse secrète',
            password: 'Mot de passe',
            passwordOld: 'Ancien mot de passe',
            passwordNew: 'Nouveau mot de passe',
            passwordRep: 'Confirmer nouveau mot de passe'
          },
          btn: {
            salva: 'Sauvegarder',
            annulla: 'Annuler'
          }
        }
      },
      es_ES: {
        profilo: {
          label: {
            mail: 'Email',
            modifica: 'Modificación',
            domanda: 'Pregunta Secreta',
            risposta: 'Respuesta Secreta',
            password: 'Contraseña',
            passwordOld: 'Antigua contraseña',
            passwordNew: 'Nueva contraseña',
            passwordRep: 'Confirmar contraseña'
          },
          btn: {
            salva: 'Guardar',
            annulla: 'Anular'
          }
        }
      },
      de_DE: {
        profilo: {
          label: {
            mail: 'E-Mail',
            modifica: 'Korrektur',
            domanda: 'Geheimfrage',
            risposta: 'Geheimantwort',
            password: 'Passwort',
            passwordOld: 'Altes Passwort',
            passwordNew: 'Neues Passwort',
            passwordRep: 'Passwort wiederholen'
          },
          btn: {
            salva: 'Speichern',
            annulla: 'Stornieren'
          }
        }
      },
      en_GB: {
        profilo: {
          label: {
            mail: 'e-mail',
            modifica: 'Modifica',
            domanda: 'Domanda Segreta',
            risposta: 'Risposta Segreta',
            password: 'Password',
            passwordOld: 'Vecchia Password',
            passwordNew: 'Nuova Password',
            passwordRep: 'Conferma Password'
          },
          btn: {
            salva: 'Salva',
            annulla: 'Annulla'
          }
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      tabActive: 'mailForm',
      tabActivePrev: 'mailForm',
      isErrorMail: false,
      mailForm: {
        mail: '',
        pwd: ''
      },
      questionForm: {
        question: '',
        answer: '',
        pwd: ''
      },
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        newPwdRep: ''
      },
      secretQuestions: [{
        value: 'q1'
      }, {
        value: 'q2'
      }, {
        value: 'q3'
      }, {
        value: 'q4'
      }, {
        value: 'q5'
      }, {
        value: 'q6'
      }, {
        value: 'q7'
      }, {
        value: 'q8'
      }]
    }
  },
  watch: {
    // whenever question changes, this function will run
    '$store.state.mail': function () {
      this.mailForm.mail = this.$store.state.mail
    }
  },
  mounted: function () {
    this.mailForm.mail = this.$store.state.mail
  },
  methods: {
    changeMail: function () {
      this.loading = true
      var obj = {
        mail: this.mailForm.mail,
        pwd: this.mailForm.pwd
      }
      this.$http.post('dipendente/' + this.$store.state.country + '/changeMail', obj, { emulateJSON: true }).then(response => {
        if (response.body.rc === 0) {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'success'
          })
          // Richiamo la funziona di salvataggio mail su Vuex nel component HeaderApp
          this.$emit('setChangeMail', this.mailForm.mail)
        } else {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'error'
          })
        }
        this.$set(this.mailForm, 'pwd', '')
        this.loading = false
      })
    },
    changeQuest: function () {
      this.loading = true
      var obj = {
        question: this.questionForm.question,
        answer: this.questionForm.answer,
        pwd: this.questionForm.pwd
      }
      this.$http.post('dipendente/' + this.$store.state.country + '/changeQuest', obj, { emulateJSON: true }).then(response => {
        if (response.body.rc === 0) {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'error'
          })
        }
        this.$set(this, 'questionForm', {})
        this.loading = false
      })
    },
    changePwd: function () {
      let correctInput = true
      if (this.pwdForm.oldPwd === '' || this.pwdForm.newPwd === '' || this.pwdForm.newPwdRep === '') {
        correctInput = false
        this.$message({
          message: 'Inserire tutti i dati',
          type: 'error'
        })
      }
      if (this.pwdForm.newPwd != this.pwdForm.newPwdRep) {
        correctInput = false
        this.$message({
          message: 'Le password non coincidono',
          type: 'error'
        })
      }
      if (correctInput) {
        this.loading = true
        var obj = {
          oldPwd: this.pwdForm.oldPwd,
          newPwd: this.pwdForm.newPwd,
          newPwdRep: this.pwdForm.newPwdRep
        }
        this.$http.post('dipendente/' + this.$store.state.country + '/changePwd', obj, { emulateJSON: true }).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'success'
            })
          } else {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'error'
            })
          }
          this.$set(this, 'pwdForm', {})
          this.loading = false
        })
      }
    },
    clearError: function () {
      this.isErrorMail = false
    },
    tabClick: function (tab, event) {
      if (this.tabActive !== this.tabActivePrev) {
        this.tabActivePrev = this.tabActive
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.profilo {

  .form-profilo {
    margin-bottom: 20px;
    margin-top: 20px;

    .row-custom {
      margin-bottom: 10px;

      .profilo-label {
        height: 22px;
        line-height: 23px;
      }

      .profilo-value {
        height: 22px;

        .dt-picker-profilo {
          width: 100%;

          .el-input__inner {
            padding-left: 30px !important;
          }

          .el-input__prefix {
            left: 0px;

            .el-input__icon {
              line-height: 22px;
              width: 17px;
            }
          }

          .el-input__suffix {
            .el-input__icon {
              line-height: 22px;
              width: 17px;
            }
          }
        }

        .el-input {
          &.is-disabled {
            .el-input__inner {
              border: none;
            }
          }

          .el-input__inner {
            border: none;
            border-bottom: 1px solid #dcdfe6;
            border-radius: 0px;
            height: 22px;
            padding-left: 0px;
            line-height: 0px;
            .set-font(@size: 14px);
          }

          .el-input__suffix {
            .el-input__icon {
              line-height: 22px;
              width: 17px;
            }
          }
        }

        .el-select {
          height: 22px;
          width: 100%;

          .el-input {
            height: 22px;

            .el-input__inner {
              border: none;
              border-bottom: 1px solid #dcdfe6;
              border-radius: 0px;
              height: 22px !important;
              padding-left: 0px;
              .set-font(@size: 14px);
            }
          }
        }
      }
    }
  }

  .el-tabs {
    .el-tabs__header {
      border-bottom: 1px solid #ccc;
      margin-bottom: 0px;

      .el-tabs__nav-wrap {
        margin-top: 0px;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav {
        border: 0px;
        height: 33px;

        .el-tabs__item {
          text-align: center;
          padding-left: 0px;
          padding-right: 0px;
          border: 0px;
          height: 30px;
          line-height: 30px;
          .set-font(@color: #999);
          letter-spacing: 1px;

          &.is-active {
            .set-font(@weight: bold);

            // background-color: #efe8da;
            .barra {
              background-image: linear-gradient(to right, @oroRiva, @greenRiva);
              height: 3px;
            }
          }
        }

        .el-tabs__item:hover {
          color: @greenRiva;
        }
      }
    }

    .el-tabs__content {
      .el-table::before {
        height: 0px;
      }
    }
  }

  .action {
    text-align: right;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Profilo/Profilo.vue